export const getLocalLicenseQueryKey = ["getLocalLicense"];
export const getSecondaryMachineIdKey = ["getSecondaryMachineId"];
export const getServerTimeQueryKey = ["getServerTime"];
